<template>
  <div class="shownav">
    <template v-if="CHANNEL_CHANNELTYPE">
      <v-touch @tap="geSort('全面评估')" class="shownav-box">
        <div class="shownav-box-icon qmpg-icon"></div>
        <div class="shownav-box-text">全面评估</div>
      </v-touch>
      <v-touch @tap="geSort('健康')" class="shownav-box">
        <div class="shownav-box-icon jkcp-icon"></div>
        <div class="shownav-box-text">健康测评</div>
      </v-touch>
      <v-touch @tap="geSort('性格')" class="shownav-box">
        <div class="shownav-box-icon xgcs-icon"></div>
        <div class="shownav-box-text">性格测试</div>
      </v-touch>
      <v-touch @tap="geSort('职场')" class="shownav-box">
        <div class="shownav-box-icon zccs-icon"></div>
        <div class="shownav-box-text">职场测试</div>
      </v-touch>
    </template>
    <template v-else>
       <!-- 临时需求关闭趣味测试 -->
      <v-touch @tap="geSort('趣味测试')" class="shownav-box">
        <div class="shownav-box-icon icon-fun"></div>
        <div class="shownav-box-text">趣味测试</div>
      </v-touch>
      <v-touch @tap="geSort('全部')" class="shownav-box">
        <div class="shownav-box-icon icon-nor"></div>
        <div class="shownav-box-text">专业测评</div>
      </v-touch>
      <v-touch @tap="geSort('全面评估')" class="shownav-box">
        <div class="shownav-box-icon icon-pro"></div>
        <div class="shownav-box-text">全面评估</div>
      </v-touch>
    </template>

  </div>
</template>

<script>
export default {
  name: 'test',
  components: {},
  data() {
    return {}
  },
  watch: {},
  props: {},
  computed: {},
  mounted() {},
  methods: {
    geSort(type) {
      this.$emit('viewMoreSort', type)
      this.$stat.send({ name: '点击首页快捷入口', properties: { 按钮: type } })
      // 微站-测评大厅-查看测评分类 神策埋点
      this.$wechatTrackEvent('weizhan_cepinghome_checktestsort', {
        test_sort: type == '全部' ? '专业测试' : type,
      });
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/function.scss';
.shownav {
  width: topx(670rem);
  height: topx(162rem);
  margin: topx(10rem) topx(40rem) 0 topx(40rem);
  display: flex;
  background: #ffffff;
  border-radius: topx(10rem);
  overflow: hidden;
  box-shadow: 0 0 topx(10rem) 0 rgba(76, 75, 88, 0.05);
  .icon-fun {
    width: topx(61rem);
    height: topx(53rem);
    background: url('../../../assets/index/icon-fun.png') center no-repeat;
    background-size: 100% 100%;
  }
  .icon-nor {
    width: topx(61rem);
    height: topx(53rem);
    background: url('../../../assets/index/icon-nor.png') center no-repeat;
    background-size: 100% 100%;
  }
  .icon-pro {
    width: topx(61rem);
    height: topx(53rem);
    background: url('../../../assets/index/icon-pro.png') center no-repeat;
    background-size: 100% 100%;
    position: relative;
    &::before {
      content: '';
      width: topx(39rem);
      height: topx(20rem);
      position: absolute;
      top: topx(-10rem);
      right: -50%;
      background: url('../../../assets/index/icon-pro_tis.png') center no-repeat;
      background-size: 100% 100%;
      display: inline-block;
    }
  }
  .jkcp-icon {
    width: topx(61rem);
    height: topx(53rem);
    background: url('../../../assets/index/jkcp-icon.png') center no-repeat;
    background-size: 100% 100%;
  }
  .qmpg-icon {
    width: topx(61rem);
    height: topx(53rem);
    background: url('../../../assets/index/qmpg-icon.png') center no-repeat;
    background-size: 100% 100%;
  }
  .xgcs-icon {
    width: topx(61rem);
    height: topx(53rem);
    background: url('../../../assets/index/xgcs-icon.png') center no-repeat;
    background-size: 100% 100%;
  }
  .zccs-icon {
    width: topx(61rem);
    height: topx(53rem);
    background: url('../../../assets/index/zccs-icon.png') center no-repeat;
    background-size: 100% 100%;
  }
  .shownav-box {
    flex: 1;
    .shownav-box-icon {
      // overflow: hidden;
      margin: 0 auto;
      margin-top: topx(30rem);
    }
    .shownav-box-text {
      font-size: topx(28rem);
      color: #666666;
      text-align: center;
      line-height: topx(28rem);
      text-align: center;
      margin-top: topx(15rem);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/show/index/showindexNav.vue